/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import {RESET_PASSWORD_CONFIRM} from "config/bases_url";
import checkout from "./form";

const {
    formField: {
        nombre,
        preasignacion_de_carrera,
        apellido_paterno,
        apellido_materno,
        numero_de_control,
        telefonos,
        genero,
        tipo_sangre,
        foto,
        curp,
        ciclo,
        estado,
        groups,
        url_cambio_password,
        usuario_wifi,
        password_wifi,
    },
} = checkout;

const initialValues = {
    [nombre.name]: "",
    [apellido_paterno.name]: "",
    [apellido_materno.name]: "",
    [numero_de_control.name]: "",
    [genero.name]: "",
    [telefonos.name]: [],
    [tipo_sangre.name]: "",
    [foto.name]: null,
    [curp.name]: "",
    [ciclo.name]: "",
    [preasignacion_de_carrera.name]: "",
    [estado.name]: "",
    [groups.name]: [],
    [url_cambio_password.name]: `${window.location.origin}${RESET_PASSWORD_CONFIRM}`,
    [usuario_wifi.name]: "",
    [password_wifi.name]: "",
};

export default initialValues;
